import { render, staticRenderFns } from "./indexOld.vue?vue&type=template&id=835a9fb8&"
import script from "./indexOld.vue?vue&type=script&lang=js&"
export * from "./indexOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports